import React from 'react';

function OverviewSection({ label, data, image, subTitle, amountUSD, currencyUSD, amountLBP, currencyLBP, onClick }) {
  const shouldHideSubtitle = label === "Cancelled" || label === "Completed";
  const role = sessionStorage.getItem("Role");
  
  let cardClass = "card";
  let cardWidth = "15%"; 

  if (role === "Arz" || role === "Support") {
    cardClass = `${label === "New Order" || label === "Scheduled" ? "card small-card" : "card"} ${label === "New Order" ? "new-order" : ""}`;
    cardWidth = label === "New Order" || label === "Scheduled" ? "" : "";
  }

  return (
    <div className='mb-2' style={{ width: cardWidth }}>
      <div className={cardClass} onClick={onClick}>
        <div className='top-card'>
          <div className='card-desc'>
            <div className='card-text'>{label}</div>
            {!shouldHideSubtitle && <div className='sub-title'>{subTitle}</div>}
          </div>
          <img src={image} alt={label} />
        </div>
        <div className='card-number'>{data}</div> 
        <div className='amount'>
          <div className='balance-amount'>
            <div className='balance'>{amountUSD}$</div>
            <div className='currency'>{currencyUSD || "USD"}</div>
          </div>
          <div className='balance-amount'>
            <div className='balance'>{amountLBP} L.L</div>
            <div className='currency'>{currencyLBP || "USD"}</div> 
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverviewSection;
